import { useState } from "react";

const useLoading = () => {
  const [loading, setLoading] = useState(false);

  const withLoading = async (callback) => {
    setLoading(true);
    try {
      await callback();
    } finally {
      setLoading(false);
    }
  };

  return { loading, withLoading };
};

export default useLoading;